import digitalPrinting from "./templates/digital-printing";
import additionalOpportunity from "./templates/additional-opportunity";

export default [
  {
    id: `material`,
    title: `Крой и качество материала`,
    content: {
      description: `<p>Отличный подарок для хозяйки или хозяина - фартук с уникальным рисунком или фотографией. Фартук изготовлен из приятного на ощупь материала. Рисунок наносится методом термотрансфера. Ткань легко стирается, практически не мнется. Краска хорошо ложится на ткань фартука и при правильной эксплуатации долго сохраняет яркость цветов.</p><p>Размеры фартука:</p><p>Длина 77-78 см</p><p>Ширина 70-71 см</p>`
    }
  },
  {
    id: `printing`,
    title: `Способ печати`,
    content: {
      printingInfo: `${digitalPrinting}${additionalOpportunity}`
    }
  },
  {
    id: `price`,
    title: `Цены`
  },
  {
    id: `delivery`,
    title: `Доставка и оплата`
  },
  {
    id: `reviews`,
    title: `Отзывы`
  }
];
